export default __webpack_public_path__ + "static/media/forgot-password-office.d1630a33.jpeg";